import IconTargetedMarket from '../assets/icon_targeted_market.svg';
import IconGrowth from '../assets/icon_growth.svg';
import IconMarkets from '../assets/icon_markets.svg';
import IconPartner from '../assets/icon_partner.svg';
import IconChart from '../assets/icon_chart.svg';
import IconOffMarket from '../assets/icon_off_market.svg';
import IconBackground from '../assets/icon_background.svg';
import IconTrackRecord from '../assets/icon_trackrecord.svg';
import IconReferences from '../assets/icon_references.svg';
import ImgPanelOpportunity from '../assets/img_panel_opportunity1.jpg';
import ImgPanelStairs from '../assets/img_panel_stairs.jpg';
import ImgPanelIncome from '../assets/img_panel_income.jpg';
import ImgPanelTenants from '../assets/img_panel_tenants.jpg';
import ImgPanelSiteVisit from '../assets/img_panel_sitevisit.jpg';

export default {
  opportunity: {
    bg: 'white',
    heading: 'Evaluating an opportunity for investment',
    body: [
      'The RealtyMogul platform requires due diligence on every investment prior to being offered to investors on the website. Every deal is evaluated against 4 core criteria to ensure investments meet the eligibility criteria. On the RealtyMogul website, investors can find deal specific information to perform their own due diligence with ease.',
    ],
    image: ImgPanelOpportunity,
  },
  realEstateCompany: {
    title: 'The Real Estate Company',
    subtitle: 'The first part of the RealtyMogul due diligence process is to analyze the real estate company. The company is the individual or group of individuals who will acquire the real estate and execute a business plan for the ownership. There are multiple factors to consider when evaluating a partner company.',
    items: [
      {
        image: IconBackground,
        title: 'Background',
        body: 'Background and criminal checks are conducted to identify any pending litigation or items of concern.',
      },
      {
        image: IconTrackRecord,
        title: 'EXPERIENCE',
        body: 'All assets previously acquired by the real estate company are examined and compared to the scope of the proposed project to review if the sponsor has similar experience.',
      },
      {
        image: IconReferences,
        title: 'REFERENCES',
        body: 'References from lenders, investors, and/or business associates are secured.',
      },
    ],
  },
  theMarket: {
    heading: 'THE MARKET',
    body: [
      'The second part of due diligence is focused on the market where the property is located. Realtors often say that the only thing that matters is "location, location, location" and, with good reason. The market of an asset is of critical importance when determining whether to make an investment. Things taken into consideration include the demographics, economic trends, and comparables in the market.',
    ],
    insights: [
      {
        icon: IconTargetedMarket,
        heading: 'Demographics',
        text: 'Key factors examined include items such as median household income, average age of population, and household formations.',
      },
      {
        icon: IconGrowth,
        heading: 'Economic Trends',
        text: 'Trends in the overall size of the market, property values, employment rates,  growth, and industry growth are reviewed.',
      },
      {
        icon: IconMarkets,
        heading: 'Comparables',
        text: 'Sales and lease information of comparable properties within the submarket of the potential investment property are reviewed.',
      },
    ],
  },
  theProperty: {
    title: 'The Property',
    subtitle: 'The third factor considered is the quality of the property or asset, including the current physical condition and the proposed business plan or capital expenditure plan to renovate the property.',
    items: [
      {
        image: ImgPanelIncome,
        title: 'Income & Cost',
        body: 'The third factor considered is the quality of the property or asset, including the current physical condition and the proposed business plan or capital expenditure plan to renovate the property. ',
      },
      {
        image: ImgPanelTenants,
        title: 'TENANTS & RENTAL RATES',
        body: 'The tenant population is examined and the vacancy and rental rates of the asset are compared to the market.',
      },
      {
        image: ImgPanelSiteVisit,
        title: 'Site Visit',
        body: 'A RealtyMogul team member travels to the property to confirm the property’s location, building characteristics, and condition.  Seeing an asset in person is a core tenant of the due diligence process.',
      },
    ],
  },
  theInvestment: {
    heading: 'The Investment',
    body: [
      'In the final stages of the RealtyMogul due diligence process, the operating agreement is reviewed for adherence to minimum qualifications. There are several key provisions reviewed when considering how the legal structure may contribute to the overall risks of a transaction.',
    ],
    insights: [
      {
        icon: IconPartner,
        heading: 'Operating Agreement',
        text: 'Legal staff works to review the operating agreement so it properly reflects the spirit of the partnership.',
      },
      {
        icon: IconChart,
        heading: 'Fees & Expenses',
        text: 'Fees, both fixed and incentive based, as well as expenses are analyzed to ensure they have been disclosed to investors.',
      },
      {
        icon: IconOffMarket,
        heading: 'Asset Management',
        text: 'The asset management team is regularly updated on the investment to report the investment’s performance over time after the deal closes, throughout the ownership cycle.',
      },
    ],
  },
  professionals: {
    section1: {
      bgImage: ImgPanelStairs,
      header: 'FEET ON THE GROUND',
      body: [
        'A member of the RealtyMogul team steps foot on every property to confirm the property’s location, building characteristics and condition.',
      ],
    },
    section2: {
      topCard: {
        header: 'Save time & Resources',
        body: 'On every deal, the platform provides investors with a convenient online overview package for them to conduct their own due diligence process.',
      },
      bottomCard: {
        header: 'Team up with professionals',
        body: 'The RealtyMogul platform is here to help you on your real estate investing journey.  At any time, you can reach out to a Member Relations team member for questions about the platform.',
      },
    },
  },
  leadership: {
    heading: 'REAL ESTATE TEAM',
    items: [],
  },
};
